<!-- 各企业类型下 首席服务员数排名 -->
<template>
    <div class='left1_container box_v'>
        <div class="title1">审核状态统计</div>
        <div class="listbox box_v">
          <div class="conlist box box_between">
            <div class="conlistleft box_v ac box_center">
              <span>幼</span><span>升</span><span>小</span>
            </div>
            <div class="conlistright box_v box_center">
              <div class="itembox box ac">
                <div class="itemname itemname1">上报审核</div>
                <div class="itemrange itemrange1"><span></span></div>
                <div class="itemnum itemnum1">100人</div>
              </div>
              <div class="itembox box ac">
                <div class="itemname itemname2">审核成功</div>
                <div class="itemrange itemrange3"><span></span></div>
                <div class="itemnum itemnum2">1100人</div>
              </div>
              <div class="itembox box ac">
                <div class="itemname itemname3">审核失败</div>
                <div class="itemrange itemrange3"><span></span></div>
                <div class="itemnum itemnum3">111010人</div>
              </div>
            </div>
          </div>
          <div class="conlistline"></div>
          <div class="conlist box box_between">
            <div class="conlistleft box_v ac box_center">
              <span>五</span><span>升</span><span>六</span>
            </div>
            <div class="conlistright box_v box_center">
              <div class="itembox box ac">
                <div class="itemname itemname1">上报审核</div>
                <div class="itemrange itemrange1"><span></span></div>
                <div class="itemnum itemnum1">100人</div>
              </div>
              <div class="itembox box ac">
                <div class="itemname itemname2">审核成功</div>
                <div class="itemrange itemrange3"><span></span></div>
                <div class="itemnum itemnum2">1100人</div>
              </div>
              <div class="itembox box ac">
                <div class="itemname itemname3">审核失败</div>
                <div class="itemrange itemrange3"><span></span></div>
                <div class="itemnum itemnum3">111010人</div>
              </div>
            </div>
          </div>
          <div class="conlistline"></div>
          <div class="conlist box box_between">
            <div class="conlistleft box_v ac box_center">
              <span>小</span><span>升</span><span>初</span>
            </div>
            <div class="conlistright box_v box_center">
              <div class="itembox box ac">
                <div class="itemname itemname1">上报审核</div>
                <div class="itemrange itemrange1"><span></span></div>
                <div class="itemnum itemnum1">100人</div>
              </div>
              <div class="itembox box ac">
                <div class="itemname itemname2">审核成功</div>
                <div class="itemrange itemrange3"><span></span></div>
                <div class="itemnum itemnum2">1100人</div>
              </div>
              <div class="itembox box ac">
                <div class="itemname itemname3">审核失败</div>
                <div class="itemrange itemrange3"><span></span></div>
                <div class="itemnum itemnum3">111010人</div>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
    //这里存放数据
        return {
            list:[]
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        getData(){
            this.$get(this.urlobj.cheifNumber).then(res=>{
                let max = res.rows[0].count
                this.list = res.rows.map(item=>{
                    return{
                        ...item,
                        count:item.count.toLocaleString(),
                        width:(item.count/max)*100 + '%'
                    }
                })
            })
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getData()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.left1_container{
    width: 100%;
    background-image: url('../../../../assets/images/monitorpy/right-s.png');
    background-size: 100% 100%;
    height:100%;
}
.title1{
    font-size: 18px;
    font-weight: bold;
    color: #FFFFFF;
    margin:20px 0 0 40px
}
.listbox{width: 100%;}
.conlist{height: 70px;width: 100%;}
.conlistline{width: 98%;height: 1px;margin: 0 auto;background: #0096FF;}
.conlistleft{width: 40px;font-size: 14px;color: #FFFFFF;line-height:14px;}
.conlistright{height: 70px;}
.itembox{height: 14px;margin-top: 3px;}
.itembox:nth-child(1){margin-top: 0;}
.itemname1{font-size: 12px;font-style: italic;color: #00E1FF;}
.itemname2{font-size: 12px;background: linear-gradient(0deg, #00D8B7 0%, #00C38A 100%);
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;font-style: italic;}
.itemname3{font-size: 12px;color: #FF5959;font-style: italic;}
.itemrange{width: 270px;height: 6px;background: #1D3370;border-radius: 3px;margin-left: 23px;}
.itemrange1 span{width: 162px;height: 6px;background: linear-gradient(90deg, #22A5FF 0%, #00E4FF 100%);border-radius: 3px;display: block;}
.itemrange2 span{width: 162px;height: 6px;background: linear-gradient(90deg, #00D8B7 0%, #00C38A 100%);border-radius: 3px;display: block;}
.itemrange3 span{width: 162px;height: 6px;background: linear-gradient(90deg, #FF8989 0%, #FF311C 100%);border-radius: 3px;display: block;}
.itemnum{font-size: 14px;margin-right: 10px;font-weight: 400;font-style: italic;color: #FFFFFF;font-weight:600;min-width:66px;text-align: right;}
.itemnum1{background: linear-gradient(0deg, #00F6FF 0%, #0290FE 100%);
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;}
.itemnum2{background: linear-gradient(0deg, #00D8B7 0%, #00C38A 100%);
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;}
.itemnum3{background: linear-gradient(0deg, #FF9090 0%, #FF311C 100%);
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;}


</style>
